<ng-template #content let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 col-md-8 offset-md-2 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">
                                Contacto
                            </div>
                        </div>
                        <div class="col-2 text-end pt-2">
                            <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
    <div class="offcanvas-body">
        <div class=" container">

            <div class="row">
                <div class=" col-12 col-md-8 offset-md-2">

                    <app-search-client (close)="closeAddClient()"></app-search-client>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<div class="container">
    <!-- Header Section -->
    <div class="header-section">
        <h1 class="page-title">
            <i class="fas fa-users"></i>
            Contactos - Estatus
        </h1>
        <p class="subtitle">Gestiona el estatus y aprobación de todos tus contactos</p>
    </div>

    <!-- Filters Section -->
    <div class="filters-section">
        <div class="filters-grid">
            <div class="filter-item">
                <div class="form-floating">
                    <select (change)="getPeople(true)" [(ngModel)]="approveStatus" class="form-select" id="floatingSelect1" aria-label="Floating label select example">
                        <option value="ALL">Todos</option>
                        <option value="REFUSED">Rechazado</option>
                        <option value="APPROVED">Aprobado</option>
                    </select>
                    <label for="floatingSelect1">Estatus</label>
                </div>
            </div>

            <div class="filter-item">
                <div class="form-floating">
                    <select (change)="getPeople(true)" [(ngModel)]="biometricStatus" class="form-select" id="floatingSelect2" aria-label="Floating label select example">
                        <option value="ALL">Todos</option>
                        <option value="Accepted">Aprobado</option>
                        <option value="Pending">Pendiente</option>
                        <option value="Declined">Rechazado</option>
                    </select>
                    <label for="floatingSelect2">Biometria</label>
                </div>
            </div>

            <div class="filter-item">
                <div class="form-floating">
                    <select (change)="getPeople(true)" [(ngModel)]="onboardingStatus" class="form-select" id="floatingSelect3" aria-label="Floating label select example">
                        <option value="ALL">Todos</option>
                        <option value="COMPLETE">Completado</option>
                        <option value="IN_PROGRES">Pendiente</option>
                    </select>
                    <label for="floatingSelect3">Onbordig</label>
                </div>
            </div>

            <div class="filter-item toggle-item">
                <label class="toggle-label">
                    En revision
                    <ng-toggle (change)="toogleStatusClient()" [(ngModel)]="usQuoteClien" [value]="true" [color]="{
                        checked: '#01abce',
                        unchecked: '#dcdcdc'
                    }"></ng-toggle>
                </label>
            </div>
        </div>
    </div>

    <!-- Results Section -->
    <div *ngIf="people" class="results-section">
        <!-- Results Header -->
        <div class="results-header">
            <h3 class="results-title">Listado de Contactos</h3>
            <div class="results-count">{{rows.length}} de {{people_total}}</div>
            <div class="reload-section">
                <div class="float-end text-primary" *ngIf="!reloadStadisticLoading && usQuoteClien" (click)="executeReview()">
                    <i class="fas fa-sync-alt"></i>
                </div>
                <div class="small" *ngIf="!reloadStadisticLoading">Ult. actualización</div>
                <div class="small" *ngIf="reloadStadisticLoading">actualizando...</div>
            </div>
        </div>

        <!-- Contacts Grid -->
        <div class="contacts-grid" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" (scrolledUp)="onScrollUp()">
            
            <!-- Contact Cards -->
            <div 
                *ngFor="let item of rows; let i=index" 
                class="contact-card"
            >
                <!-- Avatar -->
                <div 
                    class="contact-avatar"
                    [ngClass]="{'active': usersActives[item?.params?.code]}"
                    [style.background-image]="'url(' + (item?.params?.selfie || '../assets/public/images/avatar.png') + ')'"
                >
                </div>

                <!-- Contact Info -->
                <div class="contact-info">
                    <div class="contact-name">
                        {{item?.params?.name}} {{item?.params?.lastName}}
                    </div>
                    <div class="contact-identity">
                        {{item?.params?.code_identity}}{{item?.params?.identity}}
                    </div>
                    <div class="contact-details">
                        {{item?.params?.phone}} / {{item?.params?.email}}
                    </div>
                    <div class="contact-executive" *ngIf="item?.person?.ejecutive">
                        <i class="fas fa-user-tie"></i>
                        Ejecutivo: {{item?.person?.ejecutive?.name}} {{item?.person?.ejecutive?.lastName}}
                    </div>
                    <div class="contact-badges">
                        <span class="status-badge status-biometric" *ngIf="item?.params?.person_biometric_status">
                            Biometría: {{item?.params?.person_biometric_status}}
                        </span>
                        <span class="status-badge status-onboarding" *ngIf="item?.params?.onboarding_status">
                            Onboarding: {{item?.params?.onboarding_status}} / {{item?.params?.onboarding_sections_complete}}
                        </span>
                        <span class="status-badge status-approve" *ngIf="item?.params?.approve_status">
                            Estatus: {{item?.params?.approve_status}}
                        </span>
                        <span class="status-badge status-review" *ngIf="item?.params?.review">
                            En revisión
                        </span>
                    </div>
                </div>

                <!-- Contact Meta -->
                <div class="contact-meta">
                    <div class="contact-date">
                        {{item?.params?.date | date: 'dd/MM/yyyy'}}
                        <br>
                        {{item?.params?.date | date: 'h:mm:ss a'}}
                    </div>
                    <button 
                        type="button"
                        class="contact-action btn btn-link p-0 text-decoration-none" 
                        (click)="debugAndOpenModal(item)"
                        [disabled]="!item?.params?.code"
                        title="Abrir revisión de cliente en modal"
                    >
                        <i class="fas fa-external-link-alt me-1"></i>
                        Revisión
                        <span *ngIf="!item?.params?.code" class="text-danger small">(Sin código)</span>
                    </button>
                </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="!loading && rows.length < 1" class="empty-state">
                <i class="fas fa-users"></i>
                <h3>No se encontraron contactos</h3>
                <p>Ajusta los filtros para ver más resultados</p>
            </div>

            <!-- Load More Button -->
            <div *ngIf="!loading && rows.length > 0" class="load-more-container">
                <button type="button" class="load-more-button" (click)="nextRows()">
                    <i class="fas fa-chevron-down"></i>
                    Cargar más contactos
                </button>
            </div>

            <!-- Loading State -->
            <div *ngIf="loading" class="loading-container">
                <div class="loading-spinner"></div>
                <p>Cargando contactos...</p>
            </div>
        </div>
    </div>
</div>